import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { inspirationProjects } from '../../mocks/inspiration';

export default function InspirationPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gray-900">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/95f0557c7b30d9caff6ca9367e7e62b5.jpg"
            alt="Inspiration Hero"
            className="w-full h-full object-cover object-center opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 via-gray-900/60 to-gray-900"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <div className="inline-block px-4 py-1.5 bg-amber-500/20 rounded-full mb-6">
            <span className="text-xs font-semibold uppercase tracking-wider text-amber-400">
              {t('common:inspiration.label')}
            </span>
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            {t('common:inspiration.title')}
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto mb-8">
            {t('common:inspiration.subtitle')}
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {['all', 'residential', 'hospitality', 'commercial'].map((category) => (
              <button
                key={category}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  category === 'all'
                    ? 'bg-gray-900 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {t(`common:inspirationPage.categories.${category}`)}
              </button>
            ))}
          </div>

          {/* Projects Masonry Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {inspirationProjects.map((project, index) => (
              <Link
                key={project.id}
                to="/dealer-registration"
                className={`group relative rounded-2xl overflow-hidden cursor-pointer ${
                  index === 0 || index === 5 ? 'md:col-span-2 lg:col-span-2' : ''
                }`}
              >
                <div className={`relative ${
                  index === 0 || index === 5 ? 'aspect-[16/9]' : 'aspect-[4/5]'
                }`}>
                  <img
                    src={project.image}
                    alt={`${project.title} - ${project.model}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-3 py-1 bg-amber-500/90 rounded-full text-xs font-medium text-black">
                      {project.category}
                    </span>
                    <span className="px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium text-white">
                      {project.model}
                    </span>
                  </div>
                  <h3 className="text-xl lg:text-2xl font-bold text-white mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {project.title}
                  </h3>
                  <p className="text-sm text-gray-300 mb-3">{project.location}</p>
                  <div className="flex items-center gap-2 text-amber-400 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span>{t('common:inspiration.viewProject')}</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            {t('common:inspirationPage.cta.title')}
          </h2>
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto">
            {t('common:inspirationPage.cta.description')}
          </p>
          <Link
            to="/dealer-registration"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-semibold rounded-full hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg cursor-pointer whitespace-nowrap"
          >
            {t('common:inspirationPage.cta.button')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
